import React, { useEffect, useRef } from "react"
import { css } from "@jsUtils"

import Styles from "./contentcopy.module.scss"

const ContentCopy = ({ data, noMd, extraStyles }) => {
  let internal = "exo.inc"
  const contentRef = useRef(null)

  useEffect(() => {
    const isBrowser = typeof window !== "undefined"
    if (isBrowser) {
      //  GET THE CURRENT URL
      internal = window.location.host.replace("www.", "")
    }
    const convertedInternal = new RegExp(internal, "i")
    const myElement = document.createElement("div")
    myElement.innerHTML = data
    const a = myElement.getElementsByTagName("a")
    for (let i = 0; i < a.length; i++) {
      const href = a[i].host.replace("www.", "") // set the host of each link
      if (!convertedInternal.test(href)) {
        // make sure the href doesn't contain current site's host
        a[i].setAttribute("target", "_blank") // if it doesn't, set attributes
      }
    }
    contentRef.current.innerHTML = myElement.innerHTML
  }, [])

  return <div ref={contentRef} className={css(!noMd && Styles.mdcopy, Styles.copy, extraStyles)} />
}

export default ContentCopy
